import { render, staticRenderFns } from "./imageShow.vue?vue&type=template&id=5e0ab3aa&scoped=true"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"
import style0 from "./imageShow.vue?vue&type=style&index=0&id=5e0ab3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ab3aa",
  null
  
)

export default component.exports